import React from 'react';
import { getContrast } from '@gik/core/utils/color';
import { gikClassPrefix } from '@gik/core/constants';

const defaultHues: Array<string> = ['50', '100', '200', '300', '400', '500', '600', '700', '800', '900'];

export interface PaletteProps {
  name?: string;
  renderItem?(name: string, value: string): React.ReactNode;
  onColorClick?(color: string, hue: string): void;
  showLabels?: boolean;
  label?: string;
  hues?: string[];
  palette: Array<string>;
  append?: React.ReactNode;
  prepend?: React.ReactNode;
}

export default function ColorPaletteCompact({
  showLabels = false,
  label = '-',
  append,
  prepend,
  palette,
  name,
  hues,
  renderItem,
  onColorClick,
}: PaletteProps): React.ReactElement {
  function handleColorClick(color: string, _hue: string) {
    if (onColorClick) onColorClick(color, _hue);
  }

  if (!palette) return null;

  const value: string = palette['500'];

  const defaultStyle = {
    background: value,
    color: getContrast(value),
  };

  const _hues: string[] = hues || defaultHues;

  const blockName = `${gikClassPrefix}-color-palette`;

  return (
    <div className={blockName}>
      <header style={defaultStyle}>
        {prepend}
        <span>{label}</span>
        {append}
      </header>
      <main>
        {palette &&
          _hues.map((hue, i) => {
            const cvalue = palette[hue];

            const style = {
              background: cvalue,
              color: getContrast(cvalue),
            };

            return (
              <div className={`${blockName}__item`} style={style} key={i} onClick={() => handleColorClick(cvalue, hue)}>
                {renderItem && renderItem(name, cvalue)}
                {!renderItem && showLabels && (
                  <span>
                    {hue} - {cvalue}&nbsp;
                  </span>
                )}
              </div>
            );
          })}
      </main>
    </div>
  );
}
